<template>
  <div class="my-0 mx-auto relative w-full max-w-full overflow-x-hidden">
    <div class="min-h-0 box-border w-full my-0 mx-auto">
      <div class="flex flex-row m-2 sm:m-4 text-base sm:text-lg gap-2 items-center flex-wrap">
        <span class="break-words">{{ $t('PersonalGoalsComponent.showCompletedGoals') }}</span>
        <ToggleSwitch class="relative inline-block toggle-width shrink-0" id="swt_showCompletedGoals"
          v-model="showCompletedGoals"/>
      </div>
      <div class="relative mx-2 sm:mx-4">
        <goal-component v-for="goal in filterActiveGoals" :key="goal._id" :goal="goal"/>
        <div v-if="showCompletedGoals">
          <goal-component v-for="goal in filterCompletedGoals" :key="goal._id" :goal="goal"/>
        </div>        
        <div v-if="!showCompletedGoals && !filterActiveGoals.length
            || !personalGoals.length" class="py-6">
          <no-personal-goals-component />
        </div>
      </div>
    </div>
  </div>
  <provide-feedback-component />
</template>
<script>
import NoPersonalGoalsComponent
  from '@/components/Home/PersonalGoalsComponent/NoPersonalGoalsComponent.vue';
import GoalComponent from '@/components/Home/HomeComponent/GoalComponent.vue';
import ProvideFeedbackComponent from '@/components/global/ProvideFeedbackComponent.vue';
import { ToggleSwitch } from 'primevue';

export default {
  name: 'PersonalGoalsComponent',
  components: {
    NoPersonalGoalsComponent,
    GoalComponent,
    ProvideFeedbackComponent,
    ToggleSwitch,
  },
  data() {
    return {
      showCompletedGoals: false,
    };
  },
  mounted() {
    this.$store.dispatch('getPersonalGoals');
  },
  computed: {
    personalGoals() {
      const personalGoalsArray = this.$store.getters.getPersonalGoals;
      if (!personalGoalsArray || personalGoalsArray.length === 0) {
        return false;
      }
      return personalGoalsArray;
    },
    filterActiveGoals() {
      const personalGoalsArray = this.$store.getters.getPersonalGoals;
      const activeGoals = personalGoalsArray.filter((goal) => goal.status === 'active');
      this.$store.commit('setActiveGoalsCount', activeGoals.length);
      return activeGoals;
    },
    filterCompletedGoals() {
      const personalGoalsArray = this.$store.getters.getPersonalGoals;
      const completedGoals = personalGoalsArray.filter((goal) => goal.status === 'completed');
      if (!completedGoals.length) {
        return false;
      }
      return completedGoals;
    },
  },
};
</script>

<style scoped>
@media screen and (max-width: 400px) {
  .toggle-width {
    width: 3.25rem !important;
  }
}
</style>
